export const AccountTypes = {
  researcher: 'researcher',
  participant: 'participant',
};
